import { createContext, useContext } from 'react';

// Suite query receipts must remain isolated across authenticated identities.
export const SuiteIdentityContext = createContext('');
export const useSuiteIdentity = () => useContext(SuiteIdentityContext);

export type SuiteDraft = {
  body: string;
  originalBody: string;
  head: number;
  revisionId: string | null;
};
export const SuiteDraftContext = createContext<{
  drafts: Record<string, SuiteDraft>;
  put: (key: string, draft: SuiteDraft) => void;
  clear: (key: string) => void;
  clearSuite: (orgId: string | undefined, suiteId: string) => void;
  clearMatching: (key: string, draft: SuiteDraft) => void;
} | null>(null);

export function useSuiteDrafts() {
  const context = useContext(SuiteDraftContext);
  if (!context) throw new Error('Suite drafts require the authenticated draft provider.');
  return context;
}

export const suiteDraftKey = (orgId: string | undefined, projectId: string, suiteId: string) =>
  JSON.stringify([orgId, projectId, suiteId]);
